import { formatFeeGroup } from '@greystar/lib';
import FeeLineItem from '../FeeLineItem/FeeLineItem';
import styles from './feeGroup.module.scss';
import { FeeGroupProps } from './FeeGroup.props';

export default function FeeGroup(props: FeeGroupProps) {
  const fees = props.fees.filter((fee) => !fee.isAdditionalPetFee);
  return (
    <div className={styles['fee-group']}>
      <h6 className={styles['fee-group-name']}>{formatFeeGroup(props.groupName)}</h6>
      {fees.map((fee) => {
        const showFeeLineItem = !props.isSummaryStep || fee.activeCount > 0;
        return showFeeLineItem ? (
          <FeeLineItem {...props} key={fee.id} fee={fee} lineClass="group-item" proration={null} />
        ) : (
          <></>
        );
      })}
    </div>
  );
}
